module.exports = __webpack_public_path__ + "static/media/cloud.5d834f7a.svg";